module.exports = __webpack_public_path__ + "static/img/01-Vintage-57.063745d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/guitar-match/01-Vintage-57.jpg
// module id = WCu2
// module chunks = 12